import { InstructorManageInstructorsPanel } from '@features/instructors/components/header/actions-tiles/manage-instructors-panel/InstructorManageInstructorsPanel';
import { useInstructorNavigation } from '@features/instructors/hooks/use-instructor-navigation/useInstructorNavigation';
import * as React from 'react';

const InstructorManageInstructorsRoute = React.memo((): React.ReactElement => {
  const { navigateToInstructorsList } = useInstructorNavigation();

  return (
    <InstructorManageInstructorsPanel onClose={navigateToInstructorsList} />
  );
});

InstructorManageInstructorsRoute.displayName =
  'InstructorManageInstructorsRoute';

export { InstructorManageInstructorsRoute };
